'use client';

import { useRouter } from 'next/navigation';
import { Link } from '@/app_components/common/Link';
import { SearchBar } from './SearchBar';

export const NotFound = () => {
  const router = useRouter();

  return (
    <>
      <div className='flex flex-col justify-center my-[30px] mx-auto relative w-[65%]'>
        <button
          className='flex self-start items-center cursor-pointer relative top-0 left-[-48px] typography-level-5 font-semibold text-primary-hover'
          onClick={() => router.back()}
          type='button'
        >
          {/** biome-ignore lint/style/useConsistentCurlyBraces: it needs it */}
          {'<'} Back
        </button>
        <h1 className='typography-lg font-inria-serif font-bold text-center my-12'>Oops! Page not found</h1>
        <p className='text-secondary typography-level-4 px-[5vw] py-[1vw]'>
          Our apologies. It may have expired or there could be a typo. Search for what you are looking for or find what
          you need on our{' '}
          <Link
            href='/'
            variant='primary'
          >
            homepage
          </Link>
          .
        </p>
      </div>
      <SearchBar />
    </>
  );
};
